// Entry point - dynamically imports bootstrap for Module Federation
import("./bootstrap");
